@if (nextTime) {
	<h2>{{ "see_u_next_time" | langVal }}</h2>
	<div>
		<p>{{ "bye" | langVal }}</p>
	</div>
} @else {
	@switch (step) {
		@case (0) {
			<div>
				<h2>{{ "walkthrough_step_0_line_1" | langVal }}</h2>
				<div>
					<h5>{{ "walkthrough_step_0_line_2" | langVal }}</h5>
				</div>
				<h5>{{ "walkthrough_step_0_line_3" | langVal }}</h5>
				<div>
					<p>
						<button
							class="btn btn-primary"
							(click)="step = 1"
						>
							{{ "walkthrough_step_0_line_4" | langVal }}
						</button>
					</p>
					<p>
						<button
							class="btn btn-primary"
							(click)="step = 2"
						>
							{{ "walkthrough_step_0_line_5" | langVal }}
						</button>
					</p>
					<p>
						<button
							class="btn btn-primary"
							(click)="step = 3"
						>
							{{ "walkthrough_step_0_line_6" | langVal }}
						</button>
					</p>
				</div>
			</div>
		}
		@case (1) {
			<div>
				<h2>{{ "walkthrough_step_1_line_1" | langVal }}</h2>
				<div>
					<p>
						<button
							class="btn btn-primary"
							(click)="step = 2"
						>
							{{ "walkthrough_step_1_line_3" | langVal }}
						</button>
					</p>
					<p>
						<button
							class="btn btn-primary"
							(click)="step = 3"
						>
							{{ "walkthrough_step_1_line_4" | langVal }}
						</button>
					</p>
				</div>
			</div>
		}
		@case (2) {
			<div>
				<div>
					<div
						(click)="openUserDetails()"
						style="cursor: pointer"
						class="d-flex align-items-baseline justify-content-between"
					>
						<h4>{{ "walkthrough_step_2_line_1" | langVal }}</h4>
					</div>
					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_2" | langVal }}</h4>
						<div
							(click)="openCalendar()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_calendar" | langVal }}
						</div>
						<p
							(click)="openZones()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_zones" | langVal }}
						</p>
					</div>
					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_3" | langVal }}</h4>
						<p>{{ "walkthrough_step_2_line_3a" | langVal }}</p>
						<p
							(click)="openPayors()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_payors" | langVal }}
						</p>
						<p
							(click)="openItaSwitch()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_israel_invoice" | langVal }}
						</p>
					</div>
					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_4" | langVal }}</h4>
						<p
							(click)="openHeadtures()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_headtures" | langVal }}
						</p>
					</div>
					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_5" | langVal }}</h4>
						<p
							(click)="openPatientsSmsSetting()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_sms" | langVal }}
						</p>
						<p
							(click)="openAccountant()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_accountant" | langVal }}
						</p>
						<p
							(click)="openPatientsAutomaticProforma()"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_line_5c" | langVal }}
						</p>
					</div>

					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_6" | langVal }}</h4>
						<p
							(click)="modalProps = { name: 'google2fa-qr-code' }"
							style="cursor: pointer"
						>
							{{ "walkthrough_step_2_google2fa" | langVal }}
						</p>
					</div>
					<div class="d-flex align-items-baseline justify-content-between">
						<h4>{{ "walkthrough_step_2_line_7" | langVal }}</h4>
						<p>{{ "walkthrough_step_2_line_7a" | langVal }}</p>
						<p>{{ "walkthrough_step_2_line_7b" | langVal }}</p>
						<p>{{ "walkthrough_step_2_line_7c" | langVal }}</p>
						<p>{{ "walkthrough_step_2_line_7d" | langVal }}</p>
						<p>{{ "walkthrough_step_2_line_7e" | langVal }}</p>
					</div>
				</div>
			</div>
		}
		@case (3) {
			<div>
				<h2>{{ "walkthrough_step_3_line_1" | langVal }}</h2>
				<div>
					<p>{{ "walkthrough_step_3_line_2" | langVal }}</p>
				</div>
			</div>
		}
		@case (4) {
			<div>
				<h2>{{ "walkthrough_step_4_line_1" | langVal }}</h2>
				<div>
					<p>{{ "walkthrough_step_4_line_2" | langVal }}</p>
				</div>
			</div>
		}
	}
	<div
		class="circles"
		style="display: flex"
	>
		<div
			[class.active]="step == 0"
			(click)="step = 0"
		></div>
		<div
			[class.active]="step == 1"
			(click)="step = 1"
		></div>
		<div
			[class.active]="step == 2"
			(click)="step = 2"
		></div>
		<div
			[class.active]="step == 3"
			(click)="step = 3"
		></div>
		<div
			[class.active]="step == 4"
			(click)="step = 4"
		></div>
		<!--    <div-->
		<!--      [class.active]="step == 5"-->
		<!--      (click)="step = 5"-->
		<!--    ></div>-->
	</div>
	<div class="modal-btns">
		@if (step <= 2) {
			<button
				class="btn btn-primary"
				(click)="step = step + 1"
			>
				{{ "next_step" | langVal }}
			</button>
			<button
				class="btn btn-danger"
				(click)="nextTime = true"
			>
				{{ "next_time" | langVal }}
			</button>
		}
	</div>
	@if (step == 3) {
		<button
			class="btn btn-primary"
			(click)="step = step + 1"
		>
			{{ "finish" | langVal }}
		</button>
	}
}

@switch (modalProps?.name) {
	@case ("google2fa-qr-code") {
		<app-modal-wrap
			(onClose)="modalProps = null"
			hasExit
			title="get_2fa_key"
			modalWrapperClass="modal-default-width"
		>
			<app-google2fa-qr-code (onClose)="modalProps = null" />
		</app-modal-wrap>
	}
}
